import { useConciergeSelector } from "domains/concierge/internal/context";
import { QueriesState } from "domains/concierge/internal/types/QueriesState";

export const useQueryStatus = (query: keyof QueriesState) => {
    return useConciergeSelector((s) => s.queries[query]);
};
